import { graphql } from 'src/graphql';

export const MaybeCreateOrganization = graphql(`
  mutation maybeCreateKindeOrganization($id: ID!) {
    maybeCreateKindeOrganization(_id: $id) {
      kinde_org_id
      _id
      name
    }
  }
`);
